import { fieldWithTranslationSchema, imageMultiSchema, imageSchema, numberSchema, objectSchema, stringSchema } from "components/inputs/validationSchema";
import { TFunction } from "i18next";
import * as yup from "yup";

export const fieldNames = {
  image: "image",
  listOrderNumber: "listOrderNumber",
} as const;

export const validation = (URL_ID: string | undefined, t: TFunction) => {
  return URL_ID
    ? yup.object().shape({
        [fieldNames.image]: imageSchema(fieldNames.image, t),
        [fieldNames.listOrderNumber]: numberSchema(fieldNames.listOrderNumber, t),
      })
    : yup.object().shape({
        [fieldNames.image]: imageSchema(fieldNames.image, t),
        [fieldNames.listOrderNumber]: numberSchema(fieldNames.listOrderNumber, t),
      });
};
